export const clearStorage = () => {
 window.location.href = "/"
 return localStorage.clear()
}

export const getItem = (key: string) => {
 try {
  const item = localStorage.getItem(key)
  if (item !== null && typeof item === "string") {
   return JSON.parse(item)
  }
  return null
 } catch {
  clearStorage()
  return null
 }
}

export const setItem = (key: string, data: any) => {
 try {
  return localStorage.setItem(key, JSON.stringify(data))
 } catch {
  clearStorage()
  return null
 }
}
